<uni-form-autocomplete
    [control]="control"
    [placeholder]="placeholder"
    [required]="false"
    [options]="options$ | async"
    [isLoading]="loading$ | async"
    [isValidationOnBlur]="true"
    [margin]="false"
    filterKey="label"
></uni-form-autocomplete>